export enum layoutAreaTypes {
  Unlogged = 'UnloggedAreaLayout',
  User = 'UserAreaLayout',
  Admin = 'AdminAreaLayout',
}
